import axios from 'axios';
import * as actionTypes from '../constants/actions';

import baseUrl from '../utils/baseUrl';

export function toggleMenu() {
	return {
		type: actionTypes.MENU_TOGGLE,
	};
};

export function closeMenu() {
	return {
		type: actionTypes.MENU_CLOSE,
	};
};

export function toggleSearchMenu(menu) {
	return {
		type: actionTypes.MENU_TOGGLE_SEARCH,
		payload: menu,
	};
};

function requestData() {
	return { type: actionTypes.MENU_REQ_DATA };
};

function receiveData(json) {
	return {
		type: actionTypes.MENU_RECV_DATA,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: actionTypes.MENU_RECV_ERROR,
		payload: json,
	};
};

export function fetchMenu(menu) {
	if (menu !== 'footer' && menu !== 'social') {
		menu = 'header';
	}

	//console.log(`Fetching menu: ${menu}`);

	return function(dispatch) {
		dispatch(requestData());
		return axios({
			url: baseUrl + '/api/navigation/' + menu,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			dispatch(receiveData(response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));

			//dispatch(pushState(null, '/error'));
			console.log('menu fetch error');
			console.log(response.data);
		});
	};
};

export function setActiveMenu(menu) {
	return {
		type: actionTypes.MENU_UPDATE_SUB,
		payload: menu,
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/menus.js
 **/